import { Controller } from 'libraries/front-end-core/core/Router'
import Main from './Main'
import getUrl from 'libraries/front-end-core/core/url'
import { ACCOUNT } from 'constants/controllers'
import HeaderContainer from 'redux/containers/pages/account/HeaderContainer'

export default new Controller({
  name: ACCOUNT,
  route: '(:aol/)account(/:view(/:option))',
  controller (
    Router,
    { scrollMain, url, params: { view, option = null, aol }, query },
    render
  ) {
    const pageId = getUrl(ACCOUNT)

    render(
      { Main, HeaderContainer },
      { view, query, option, aol },
      {
        pageId,
        className: 'account',
        aol
      }
    )

    return pageId
  }
})
